export const ddToolbarConstants = {
    UPDATE_PAGE_SIZE: "UPDATE_PAGE_SIZE",
    UPDATE_IS_DELETED: "UPDATE_IS_DELETED",
    UPDATE_SEARCH: "UPDATE_SEARCH",
    UPDATE_DATE_RANGE: "UPDATE_DATE_RANGE"
};
